import {
  CustomisationOption,
  CustomisationOptionGroup,
} from '../../types/customisation';
import { CheckboxOptions } from './checkbox-options';
import { OptionalMandatoryOptions } from './optional-mandatory-options';
import { RadioOptions } from './radio-options';

export interface RadioOptionProps {
  options: CustomisationOption[];
  name: string;
  itemCount: number;
  error: boolean;
  helperText: string;
  minimumSelections?: number;
  maximumSelections?: number;
  type?: string;
}

export interface OptionalMandatoryOptionsProps {
  options: CustomisationOption[];
  name: string;
  itemCount: number;
  error: boolean;
  helperText: string;
  minimumSelections?: number;
  maximumSelections?: number;
}

export interface CheckboxOptionProps {
  options: CustomisationOption[];
  name: string;
  itemCount: number;
  helperText?: string;
  minimumSelections?: number;
  maximumSelections?: number;
  type?: string;
  error: boolean;
}

export interface CustomisationProps {
  customisation: CustomisationOptionGroup;
  itemCount: number;
  error: boolean;
  helperText: string;
  minimumSelections?: number;
  maximumSelections?: number;
}

export const inputType = {
  singleSelect: RadioOptions,
  multiSelect: CheckboxOptions,
  optional: OptionalMandatoryOptions,
  mandatory: OptionalMandatoryOptions,
};

export type AppConfigContext = {
  regionID?: string;
  accountID?: string;
  eventID?: string;
  venueID?: string;
  storeID?: string;
  categoryID?: string;
  itemID?: string;
};
